import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

const ALL_LINKS = [
  { label: "Rottebekæmpelse", to: "/ydelser/rottebekaempelse" },
  { label: "Kloakopgaver", to: "/ydelser/kloakopgaver" },
  { label: "Serviceaftale", to: "/ydelser/serviceaftale" },
  { label: "Spul & Rens", to: "/ydelser/spul-rens" },
];

export const NoDig = () => (
  <>
    <SEO
      title="No-dig – Strømpeforing af kloak uden opgravning"
      description="No-dig og strømpeforing: renovering af beskadigede rør indefra. Kort udførelsestid, minimal opgravning og skånsom løsning ved lokale skader eller ældre rør."
    />
    <ServicePageTemplate
    eyebrow="No-dig"
    title={<>Reparation af rør <em className="text-[color:var(--fk-gold)]">uden opgravning.</em></>}
    subtitle="Med strømpeforing og punktreparation kan vi renovere beskadigede rør indefra. Det betyder mindre opgravning, færre gener og en effektiv løsning, når forholdene egner sig til no-dig."
    heroImage={ASSETS.images.noDig}
    intro="No-dig er en skånsom metode til at renovere beskadigede rør indefra. Når forholdene egner sig til det, kan vi forlænge rørets levetid uden omfattende opgravning og unødvendige gener."
    bullets={[
      "Strømpeforing af eksisterende rør",
      "Punktreparation ved lokale skader",
      "Kortere udførelsestid end traditionel opgravning",
      "Færre gener for beboere, drift og adgangsforhold",
    ]}
    process={[
      { title: "TV-inspektion", body: "Vi inspicerer røret, vurderer skaden og dokumenterer, om no-dig er den rigtige løsning." },
      { title: "Rensning", body: "Vi renser røret grundigt, så det er klar til strømpeforing eller punktreparation." },
      { title: "Foring", body: "Vi udfører strømpeforing eller punktreparation indefra, uden unødvendig opgravning." },
      { title: "Aflevering", body: "Vi tester resultatet og afleverer dokumentation på det udførte arbejde." },
    ]}
    ctaHeading="Kan røret repareres uden opgravning?"
    ctaBody="Book en TV-inspektion, så vurderer vi skaden, dokumenterer forholdene og afklarer, om no-dig er den rigtige løsning."
    related={ALL_LINKS}
  />
  </>
);
